// component library
import { ProfileImage } from "thrive-components";

// services
import { ChatMessage } from "./ChatMessage.service";
import { CAS } from "../../service/ChatConfig.Service";

// components
import ChatMessagePlainTextBody from "./ChatMessageContent";
import ChatDeliveryError from "./ChatDeliveryError";

import '../../styles/ChatBubble.scss';


const ChatMessageBubble = ({message}: {message: ChatMessage}) => {
    return (
    <>
        <ChatDeliveryError 
            className={message.getErrorMessageStyle()}
        />
        <li key={message.id} className={`${message.getChatCssStyle()} ${message.getIsSendingStyle()}`}>
            {message.hasProfilePic() && 
            <div className='chat-profile-image-wrapper'>
                 <ProfileImage
                    className="chat-profile-image" 
                    profileImageUrl={message.user.value.profilePicture.uri}
                    accessToken={CAS.getAccessToken() as string}
                />
            </div>
        }
            <ChatMessagePlainTextBody
                messageText={message.formatMessageToPlainTextParts()}
                id={Number(message.id)}
            /> 
            <p className="time-stamp"> {message.getMessageSentTime()}</p>
        </li>
    </>);
} 

export default ChatMessageBubble;